import { db, serverTimestamp, arrayUnion } from '@/main';
import { RoomDoc } from '@/types';

/**
 * URLからルームIDを取得する
 * @param {RouteObject} VueRouterのrouteオブジェクト
 */
export const getRoomId = (route: any) => {
  // パラメータに同じ「id」が複数存在した場合
  let { id } = route.params;
  if (typeof id === 'object') {
    id = id[0];
  }

  return id;
};

/**
 * ユーザが参加しているルームを追加する
 * @param userId
 * @param roomId
 */
export const updateJoinRoom = async (userId: string, roomId: string) => {
  if (!userId || !roomId) throw '必要な情報が足りません';

  try {
    await db
      .collection('Users')
      .doc(userId)
      .update({
        joinRooms: arrayUnion(roomId),
        updatedAt: serverTimestamp()
      });
  } catch (e) {
    throw e;
  }
};

/**
 * FirestoreのUsers/{userId}/joinRoomsにルームIDを登録
 * @param userId
 * @param roomId
 */
export const joinThisRoom = async (userId: string, roomId: string) => {
  const isAddedThisRoom = sessionStorage.getItem(`added-${roomId}`);
  if (roomId && userId && !isAddedThisRoom) {
    try {
      await updateJoinRoom(userId, roomId);
      sessionStorage.setItem(`added-${roomId}`, 'true');
    } catch (e) {
      console.error(e);
    }
  }
};

export const isNotContainRoomInfo = (roomObj: RoomDoc) => {
  if (roomObj?.roomTitle) return true;
  if (roomObj?.roomPassword) return true;
  if (roomObj?.questionIdList) return true;
  if (roomObj?.studentNum) return true;
  if (roomObj?.expirationDate) return true;
  if (roomObj?.createdAt) return true;
  if (roomObj?.updatedAt) return true;

  return false;
};
